/* Nay Base · lógica común de los temas (carrito AJAX, variantes, pedir ahora, galería, búsqueda, agregar rápido). Sin librerías. */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const NT = window.NT || {};
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- dinero ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || NT.moneyFormat || '${{amount}}';
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const kind = m ? m[1] : 'amount';
    const fix = (n, dec, th, ds) => {
      th = th === undefined ? ',' : th; ds = ds === undefined ? '.' : ds;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(dec);
      const parts = n.split('.');
      const d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? ds + parts[1] : '');
    };
    let v;
    switch (kind) {
      case 'amount': v = fix(cents, 2); break;
      case 'amount_no_decimals': v = fix(cents, 0); break;
      case 'amount_with_comma_separator': v = fix(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fix(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fix(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fix(cents, 0, ' ', ''); break;
      default: v = fix(cents, 2);
    }
    let out = fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
    return out.replace(/([.,]00)(?=\D*$)/, '');
  }
  NT.formatMoney = formatMoney;

  /* ---------- intro ---------- */
  const intro = $('#nt-intro');
  if (intro) {
    let visto = false;
    try { visto = sessionStorage.getItem('nt-intro') === '1'; sessionStorage.setItem('nt-intro', '1'); } catch (e) {}
    if (visto || reduce) intro.classList.add('skip-now');
    else setTimeout(() => intro.remove(), 2600);
  }

  /* ---------- encabezado ---------- */
  const hdr = $('[data-header]');
  const primera = $('main > .shopify-section:first-child > section, main > .shopify-section:first-child > div');
  const arrancaOscuro = primera && primera.classList.contains('is-dark');
  function pintarHdr() {
    if (!hdr) return;
    hdr.classList.toggle('solid', !arrancaOscuro || window.scrollY > 30);
  }
  pintarHdr();
  window.addEventListener('scroll', pintarHdr, { passive: true });

  /* ---------- menú celular ---------- */
  const mm = $('#MobileMenu');
  function menu(abrir) {
    if (!mm) return;
    mm.classList.toggle('open', abrir);
    mm.setAttribute('aria-hidden', abrir ? 'false' : 'true');
    document.documentElement.style.overflow = abrir ? 'hidden' : '';
  }
  $$('[data-menu-open]').forEach(b => b.addEventListener('click', () => menu(true)));
  $$('[data-menu-close]').forEach(b => b.addEventListener('click', () => menu(false)));

  /* ---------- cursor ---------- */
  const fino = window.matchMedia('(pointer: fine)').matches;
  if (fino && document.body.classList.contains('fx-cursor') && !reduce) {
    document.body.classList.add('fine');
    const c = $('.cur'), r = $('.cur-ring');
    let x = innerWidth / 2, y = innerHeight / 2, rx = x, ry = y;
    addEventListener('pointermove', e => { x = e.clientX; y = e.clientY; if (c) c.style.transform = `translate(${x}px,${y}px) translate(-50%,-50%)`; }, { passive: true });
    (function loop() { rx += (x - rx) * .18; ry += (y - ry) * .18; if (r) r.style.transform = `translate(${rx}px,${ry}px) translate(-50%,-50%)`; requestAnimationFrame(loop); })();
    document.addEventListener('pointerover', e => { if (r) r.classList.toggle('hot', !!e.target.closest('a,button,label,input,select,summary,[data-dot]')); });
  }

  /* ---------- aparecer al bajar ---------- */
  const io = new IntersectionObserver(ents => {
    ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
  $$('[data-reveal]').forEach((el, i) => { el.style.transitionDelay = ((i % 4) * 70) + 'ms'; io.observe(el); });

  /* ---------- luz que sigue el dedo ---------- */
  $$('[data-spotlight]').forEach(el => el.addEventListener('pointermove', e => {
    const b = el.getBoundingClientRect();
    el.style.setProperty('--mx', (e.clientX - b.left) + 'px');
    el.style.setProperty('--my', (e.clientY - b.top) + 'px');
  }));

  /* ---------- escenario (héroe y producto) ---------- */
  function escenario(stage) {
    const tilt = $('[data-tilt]', stage), spot = $('[data-spot]', stage);
    const sec = stage.closest('section');
    const orb = sec ? $('[data-orb]', sec) : null;
    if (!fino || reduce) return;
    stage.addEventListener('pointermove', e => {
      const b = stage.getBoundingClientRect();
      const px = (e.clientX - b.left) / b.width, py = (e.clientY - b.top) / b.height;
      if (tilt) tilt.style.transform = `perspective(900px) rotateY(${(px - .5) * 14}deg) rotateX(${(.5 - py) * 10}deg)`;
      if (spot) { spot.style.setProperty('--mx', (px * 100) + '%'); spot.style.setProperty('--my', (py * 100) + '%'); }
      if (orb && sec) { const s = sec.getBoundingClientRect(); orb.style.left = (e.clientX - s.left) + 'px'; orb.style.top = (e.clientY - s.top) + 'px'; }
    });
    stage.addEventListener('pointerleave', () => { if (tilt) tilt.style.transform = ''; });
  }
  $$('[data-stage]').forEach(escenario);

  // carrusel del héroe
  $$('[data-hero]').forEach(hero => {
    const img = $('.hero__img', hero), t = $('[data-stage-title]', hero), p = $('[data-stage-price]', hero), l = $('[data-stage-link]', hero);
    $$('[data-rail]', hero).forEach(b => b.addEventListener('click', () => {
      $$('[data-rail]', hero).forEach(x => x.classList.toggle('on', x === b));
      if (img) { img.style.opacity = 0; setTimeout(() => { img.removeAttribute('srcset'); img.src = b.dataset.img; img.onload = () => { img.style.opacity = 1; }; }, 250); }
      if (t) t.textContent = b.dataset.title;
      if (p) p.textContent = b.dataset.price;
      if (l) l.href = b.dataset.url;
    }));
  });

  /* ---------- manifiesto ---------- */
  $$('[data-manifesto]').forEach(sec => {
    const ws = $$('.w', sec);
    if (!ws.length) return;
    let tic = false;
    const pintar = () => {
      tic = false;
      const b = sec.getBoundingClientRect(), vh = innerHeight;
      const prog = Math.min(1, Math.max(0, (vh * .85 - b.top) / (b.height * .9 + vh * .2)));
      const n = Math.round(prog * ws.length);
      ws.forEach((w, i) => w.classList.toggle('lit', i < n));
    };
    addEventListener('scroll', () => { if (!tic) { tic = true; requestAnimationFrame(pintar); } }, { passive: true });
    pintar();
  });

  /* ---------- cómo compras (camión) ---------- */
  $$('[data-steps]').forEach(sec => {
    const steps = $$('[data-step]', sec), road = $('.steps__road', sec);
    const ob = new IntersectionObserver(ents => ents.forEach(en => {
      if (!en.isIntersecting) return;
      ob.disconnect();
      const t0 = performance.now(), dur = reduce ? 1 : 2600;
      (function run(t) {
        const k = Math.min(1, (t - t0) / dur);
        if (road) road.style.setProperty('--p', (k * 100) + '%');
        steps.forEach((s, i) => s.classList.toggle('on', k >= i / steps.length));
        if (k < 1) requestAnimationFrame(run);
      })(t0);
    }), { threshold: .35 });
    ob.observe(sec);
  });

  /* ---------- chat de preguntas ---------- */
  $$('[data-chat]').forEach(chat => {
    const body = $('[data-chat-body]', chat), typing = $('[data-typing]', chat), status = $('[data-chat-status]', chat);
    const msgs = $$('[data-msg]', chat), chips = $$('[data-chip]', chat);
    if (!msgs.length) return;
    msgs.forEach(m => m.classList.add('hide'));
    const vistos = new Set();
    let ocupado = false;
    function mostrar(i) {
      if (ocupado || vistos.has(i)) return;
      ocupado = true; vistos.add(i);
      const q = msgs[i * 2], a = msgs[i * 2 + 1];
      if (chips[i]) chips[i].classList.add('used');
      q.classList.remove('hide'); body.appendChild(q); body.appendChild(typing);
      body.scrollTop = body.scrollHeight;
      setTimeout(() => {
        typing.classList.add('on'); if (status) status.textContent = 'escribiendo…';
        body.scrollTop = body.scrollHeight;
        setTimeout(() => {
          typing.classList.remove('on'); if (status) status.textContent = 'en línea';
          a.classList.remove('hide'); body.appendChild(a); body.appendChild(typing);
          body.scrollTop = body.scrollHeight; ocupado = false;
        }, reduce ? 10 : 1100);
      }, reduce ? 10 : 450);
    }
    chips.forEach(c => c.addEventListener('click', () => mostrar(+c.dataset.chip)));
    const ob = new IntersectionObserver(ents => ents.forEach(en => { if (en.isIntersecting) { ob.disconnect(); setTimeout(() => mostrar(0), 500); } }), { threshold: .4 });
    ob.observe(chat);
  });

  /* ---------- orden en colecciones ---------- */
  $$('[data-autosubmit]').forEach(s => s.addEventListener('change', () => s.form.submit()));

  /* =====================================================================
     CARRITO
     ===================================================================== */
  const drawer = $('#CartDrawer');
  function abrirCarrito(abrir) {
    if (!drawer) return;
    drawer.classList.toggle('open', abrir);
    drawer.setAttribute('aria-hidden', abrir ? 'false' : 'true');
    document.documentElement.style.overflow = abrir ? 'hidden' : '';
  }
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', () => { abrirCarrito(true); refrescarCarrito(); }));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', () => abrirCarrito(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { abrirCarrito(false); menu(false); } });

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function pintarCarrito(cart) {
    $$('[data-cart-count]').forEach(n => { n.textContent = cart.item_count; });
    $$('[data-cart-word]').forEach(n => { n.textContent = cart.item_count === 1 ? 'producto' : 'productos'; });
    const box = $('[data-cart-items]');
    if (box) {
      if (!cart.items.length) box.innerHTML = '<p class="drawer__empty">' + esc(NT.t && NT.t.empty || 'Tu carrito está vacío') + '.</p>';
      else box.innerHTML = cart.items.map(it => `
        <div class="citem" data-key="${esc(it.key)}">
          <a class="citem__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image.replace(/(\.\w+)(\?|$)/, '_180x$1$2'))}" alt="" loading="lazy">` : ''}</a>
          <div class="citem__info">
            <a class="citem__t" href="${esc(it.url)}">${esc(it.product_title)}</a>
            ${it.product_has_only_default_variant ? '' : `<p class="citem__v">${esc(it.variant_title || '')}</p>`}
            <div class="qty qty--sm">
              <button type="button" data-qty-change="-1" aria-label="Quitar uno">−</button>
              <span data-qty>${it.quantity}</span>
              <button type="button" data-qty-change="1" aria-label="Agregar uno">+</button>
            </div>
          </div>
          <div class="citem__p">${formatMoney(it.final_line_price)}</div>
        </div>`).join('');
    }
    const tot = $('[data-cart-total]'); if (tot) tot.textContent = formatMoney(cart.total_price);
    const chk = $('[data-cart-checkout]'); if (chk) chk.disabled = cart.item_count === 0;
  }
  function refrescarCarrito() {
    return fetch(NT.routes.cart, { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => { pintarCarrito(c); return c; }).catch(() => {});
  }
  if (drawer) drawer.addEventListener('click', e => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    const row = b.closest('[data-key]');
    const q = +$('[data-qty]', row).textContent + (+b.dataset.qtyChange);
    row.style.opacity = .5;
    fetch(NT.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: row.dataset.key, quantity: Math.max(0, q) }) })
      .then(r => r.json()).then(pintarCarrito).catch(() => { row.style.opacity = 1; });
  });
  // NayHogar B: si falla la red, el mensaje sale en español (antes salía "Failed to fetch")
  const sinRed = e => { throw (e instanceof TypeError) ? new Error('No se pudo agregar. Revisa tu conexión e intenta de nuevo.') : e; };
  NT.addToCart = function (id, qty) {
    return fetch(NT.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: +qty || 1 }] }) })
      .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar'); return j; }))
      .catch(sinRed);
  };
  NT.openCart = () => { abrirCarrito(true); return refrescarCarrito(); };

  /* =====================================================================
     PRODUCTO
     ===================================================================== */
  const pdp = $('[data-pdp]');
  if (pdp) initProducto(pdp);

  // el producto tiembla al tocarlo, como el masaje (idea 8, informe Rodrigo Olivares, 30 sep); en Android también vibra el celular
  function initTiriton() {
    $$('[data-tiriton]').forEach(img => {
      const hint = img.closest('[data-stage]') && $('[data-tiriton-hint]', img.closest('[data-stage]'));
      const sacudir = vib => {
        img.classList.remove('tirita'); void img.offsetWidth; img.classList.add('tirita');
        if (vib && 'vibrate' in navigator) { try { navigator.vibrate(40); } catch (e) {} }
      };
      img.addEventListener('animationend', () => img.classList.remove('tirita'));
      img.addEventListener('pointerdown', () => { sacudir(true); if (hint) hint.classList.add('is-off'); });
      if (!reduce && 'IntersectionObserver' in window) {
        const ob = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { ob.disconnect(); setTimeout(() => sacudir(false), 1100); } }), { threshold: .6 });
        ob.observe(img);
      }
    });
  }
  initTiriton();

  function initProducto(sec) {
    const dataEl = $('[data-product-json]', sec);
    if (!dataEl) return;
    const P = JSON.parse(dataEl.textContent);
    const form = $('[data-product-form]', sec);
    const idInput = $('[data-variant-id]', form);
    const inputs = $$('[data-opt-input]', form);
    const buyNow = $('[data-buy-now]', form), addBtn = $('[data-add-cart]', form), err = $('[data-buy-err]', form);
    const qtyIn = $('[data-qty-input]', form);
    const stageImg = $('[data-stage-main]', sec);
    let colorMap = {};
    try { const ca = $('[data-color-assets]', sec); if (ca) colorMap = JSON.parse(ca.textContent); } catch (e) { colorMap = {}; }
    const colorIdx = P.options.findIndex(o => /colou?r/i.test(o));
    let actual = P.variants.find(v => String(v.id) === String(idInput.value)) || P.variants[0];

    const elegidos = () => inputs.length ? P.options.map((_, i) => { const c = form.querySelector(`[data-opt-input="${i}"]:checked`); return c ? c.value : null; }) : [];
    const buscar = opts => P.variants.find(v => v.options.every((o, i) => opts[i] == null || o === opts[i]));

    function marcarAgotados() {
      const sel = elegidos();
      inputs.forEach(inp => {
        const i = +inp.dataset.optInput;
        const prueba = sel.slice(); prueba[i] = inp.value;
        const v = buscar(prueba);
        const lab = inp.closest('label');
        if (lab) lab.classList.toggle('is-out', !v || !v.available);
      });
    }

    function aplicar(v, desde) {
      if (!v) return;
      actual = v;
      idInput.value = v.id;
      // precio
      $$('[data-pdp] [data-price-wrap], .finale--pdp [data-price-wrap]').forEach(w => {
        const now = $('[data-price]', w), was = $('[data-compare]', w), save = $('[data-save]', w);
        if (now) now.textContent = formatMoney(v.price);
        if (was && save) {
          if (v.compare > v.price) { was.hidden = false; save.hidden = false; was.textContent = formatMoney(v.compare); save.textContent = '-' + Math.floor((v.compare - v.price) * 100 / v.compare) + '%'; }   // floor, igual que price.liquid (nunca exagera el descuento)
          else { was.hidden = true; save.hidden = true; }
        }
      });
      const sp = $('[data-sbar-price]'); if (sp) sp.textContent = formatMoney(v.price);
      // disponible
      const lbl = $('[data-cta-label]', form);
      [buyNow, addBtn, $('[data-sbar-buy]')].concat($$('[data-buy-trigger]')).forEach(b => { if (b) b.disabled = !v.available; });
      if (lbl) lbl.textContent = v.available ? (lbl.dataset.txt || lbl.textContent) : 'Agotado';
      // etiquetas de opción
      v.options.forEach((o, i) => { const e = form.querySelector(`[data-opt-label="${i}"]`); if (e) e.textContent = o; });
      // inventario real
      const st = $('[data-stock]', form);
      if (st) {
        const mostrar = v.managed && v.qty != null && v.qty > 0 && P.lowStock > 0 && v.qty <= P.lowStock;
        st.hidden = !mostrar;
        if (mostrar) { $('[data-stock-n]', st).textContent = v.qty === 1 ? 'Queda 1' : 'Quedan ' + v.qty; requestAnimationFrame(() => { $('[data-stock-bar]', st).style.width = Math.max(8, Math.round(v.qty * 100 / P.lowStock)) + '%'; }); }
      }
      // imagen del escenario por color
      if (stageImg && colorIdx >= 0) {
        const src = colorMap[String(v.options[colorIdx]).toLowerCase().trim()];
        if (src && stageImg.getAttribute('src') !== src) {
          stageImg.classList.add('swap');
          setTimeout(() => { stageImg.src = src; stageImg.onload = () => stageImg.classList.remove('swap'); setTimeout(() => stageImg.classList.remove('swap'), 500); }, 220);
        }
      }
      // galería de fotos: ir a la foto de la variante
      if (v.media) { const sl = sec.querySelector(`[data-media-id="${v.media}"]`); if (sl) sl.parentElement.scrollTo({ left: sl.offsetLeft, behavior: 'smooth' }); }
      // URL
      if (desde !== 'init') { try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {} }
      marcarAgotados();
      document.dispatchEvent(new CustomEvent('nt:variant', { detail: { variant: v, colorIdx, options: P.options } }));
    }

    inputs.forEach(inp => inp.addEventListener('change', () => { const v = buscar(elegidos()); if (v) aplicar(v); else if (err) { err.hidden = false; err.textContent = 'Esa combinación no está disponible.'; } }));
    // otras secciones (colores) piden un valor
    document.addEventListener('nt:select', e => {
      const { index, value } = e.detail || {};
      const inp = inputs.find(x => +x.dataset.optInput === +index && x.value === value);
      if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    const lblEl = $('[data-cta-label]', form); if (lblEl) lblEl.dataset.txt = lblEl.textContent;
    aplicar(actual, 'init');

    // cantidad
    $$('[data-qty-btn]', form).forEach(b => b.addEventListener('click', () => {
      qtyIn.value = Math.min(10, Math.max(1, (+qtyIn.value || 1) + (+b.dataset.qtyBtn)));
      qtyIn.dispatchEvent(new Event('change', { bubbles: true }));
    }));

    // comprar
    function comprar(directo, boton) {
      if (!actual || !actual.available) return;
      if (err) err.hidden = true;
      if (boton) boton.classList.add('is-loading');
      NT.addToCart(actual.id, qtyIn ? qtyIn.value : 1)
        .then(() => {
          if (directo && NT.buyNowCheckout) { location.href = NT.routes.checkout; return; }
          if (boton) boton.classList.remove('is-loading');
          NT.openCart();
        })
        .catch(x => { if (boton) boton.classList.remove('is-loading'); if (err) { err.hidden = false; err.textContent = x.message; } });
    }
    form.addEventListener('submit', e => { e.preventDefault(); comprar(true, buyNow); });
    if (addBtn) addBtn.addEventListener('click', () => comprar(false, addBtn));
    const sb = $('[data-sbar-buy]'); if (sb) sb.addEventListener('click', () => comprar(true, sb));
    $$('[data-buy-trigger]').forEach(b => b.addEventListener('click', () => comprar(true, b)));

    // barra fija: aparece cuando el botón principal sale de pantalla
    const sbar = $('[data-sbar]');
    if (sbar && buyNow) {
      const ob = new IntersectionObserver(ents => ents.forEach(en => {
        const ver = !en.isIntersecting && en.boundingClientRect.top < 0;
        sbar.classList.toggle('show', ver); document.body.classList.toggle('has-sbar', ver);
        sbar.setAttribute('aria-hidden', ver ? 'false' : 'true');
      }), { threshold: 0 });
      ob.observe(buyNow);
    }

    // galería: miniaturas
    const track = $('[data-gal-track]', sec);
    if (track) {
      const ths = $$('[data-gal-go]', sec);
      ths.forEach(t => t.addEventListener('click', () => { const s = track.children[+t.dataset.galGo]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }));
      track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); ths.forEach((t, k) => t.classList.toggle('on', k === i)); }, { passive: true });
    }
    // fotos a pantalla completa
    const lb = $('[data-lightbox]');
    $$('[data-gallery-open]').forEach(b => b.addEventListener('click', () => { if (lb && lb.showModal) lb.showModal(); }));
    if (lb) { $('[data-lightbox-close]', lb).addEventListener('click', () => lb.close()); lb.addEventListener('click', e => { if (e.target === lb) lb.close(); }); }
  }

  /* =====================================================================
     AVISO (toast), AGREGAR RÁPIDO Y BUSCADOR
     ===================================================================== */
  const toastEl = $('[data-toast]');
  let toastT = null;
  NT.toast = function (msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('on'), 2600);
  };
  // botón "Agregar" de las tarjetas (productos sin opciones)
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    NT.addToCart(b.dataset.quickAdd, 1)
      .then(() => { b.classList.remove('is-loading'); b.classList.add('is-done'); setTimeout(() => b.classList.remove('is-done'), 1600);
        NT.toast((NT.t && NT.t.added) || 'Agregado al carrito'); refrescarCarrito();
        document.dispatchEvent(new CustomEvent('nt:added', { detail: { id: b.dataset.quickAdd } })); })
      .catch(x => { b.classList.remove('is-loading'); NT.toast(x.message || 'No se pudo agregar'); });
  });
  // agregar varios de una vez (kits, listas, combos): NT.addMany([{id, quantity}]) -> abre el carrito
  NT.addMany = function (items) {
    return fetch(NT.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar'); return j; }))
      .catch(sinRed)
      .then(j => { NT.openCart(); return j; });
  };
  // buscador del encabezado con sugerencias (Shopify /search/suggest.json)
  const panel = $('[data-search-panel]');
  if (panel) {
    const input = $('[data-search-input]', panel), res = $('[data-search-results]', panel);
    $$('[data-search-open]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); panel.hidden = false; panel.classList.add('open'); setTimeout(() => input && input.focus(), 30); }));
    $$('[data-search-close]').forEach(b => b.addEventListener('click', () => { panel.classList.remove('open'); panel.hidden = true; }));
    let t = null;
    if (input && res) input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { res.innerHTML = ''; return; }
      t = setTimeout(() => {
        fetch((NT.routes.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(r => r.json()).then(j => {
            const ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            res.innerHTML = ps.length ? ps.map(p => `<a class="sugg" href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}<span><b>${esc(p.title)}</b><small>${formatMoney(Math.round(parseFloat(p.price) * 100))}</small></span></a>`).join('')
              : '<p class="sugg__none">Sin resultados. Presiona Enter para buscar en toda la tienda.</p>';
          }).catch(() => {});
      }, 220);
    });
  }
})();
